// Mag een inkoopfactuur (definitief of pro forma) verwijderd worden?
//
// Verwijderen ruimt alleen verwijzingen op (koppelingen met pro forma's, de zending). Het
// verwijdert nooit geld of iets wat al ergens anders is doorgerekend. In die gevallen blokkeren
// we, met een reden die zegt wat er eerst moet gebeuren.

// Statussen waarin "Verwerk ontvangst" de kostprijzen al heeft berekend met de betalingen op de
// factuur (en de pro forma's die eraan hangen).
export const PROCESSED_SHIPMENT_STATUSES = ["received", "completed"];

const shipmentLabel = (shipment) => shipment?.shipmentNumber || shipment?.id || "de zending";

/**
 * @param {object} params
 * @param {object} params.invoice  de factuur zelf
 * @param {number} params.paymentCount  aantal betalingen met invoiceId = deze factuur
 * @param {object|null} params.shipment  bij een definitieve factuur: zijn zending
 * @param {object|null} params.linkedFinalInvoice  bij een pro forma: de definitieve factuur waarmee hij verrekend is
 * @param {object|null} params.linkedFinalShipment  de zending van die definitieve factuur
 * @returns {string[]}  redenen waarom het niet mag; leeg = mag
 */
export const getInvoiceDeletionBlockers = ({
  invoice,
  paymentCount = 0,
  shipment = null,
  linkedFinalInvoice = null,
  linkedFinalShipment = null,
}) => {
  const blockers = [];
  if (!invoice) return ["De factuur bestaat niet meer."];

  if (paymentCount > 0) {
    blockers.push(
      paymentCount === 1
        ? "Er staat een betaling op deze factuur. Verwijder die eerst."
        : `Er staan ${paymentCount} betalingen op deze factuur. Verwijder die eerst.`,
    );
  }

  if (invoice.exactPurchaseInvoiceId) {
    blockers.push("De factuur staat al in Exact Online. Verwijderen zou daar een inkoopfactuur laten staan.");
  }

  if (invoice.type === "proforma") {
    if (linkedFinalInvoice && PROCESSED_SHIPMENT_STATUSES.includes(linkedFinalShipment?.status)) {
      blockers.push(
        `Verrekend met ${linkedFinalInvoice.invoiceNumber || linkedFinalInvoice.id}, waarvan ${shipmentLabel(linkedFinalShipment)} al is ontvangen. De kostprijzen zijn met deze aanbetaling berekend.`,
      );
    }
  } else if (PROCESSED_SHIPMENT_STATUSES.includes(shipment?.status)) {
    blockers.push(
      `${shipmentLabel(shipment)} is al ontvangen. De kostprijzen zijn met deze factuur berekend.`,
    );
  }

  return blockers;
};
